import { render } from "./AddOrEditModal.vue?vue&type=template&id=6a5eaa3c&scoped=true"
import script from "./AddOrEditModal.vue?vue&type=script&lang=js"
export * from "./AddOrEditModal.vue?vue&type=script&lang=js"

import "./AddOrEditModal.vue?vue&type=style&index=0&id=6a5eaa3c&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5eaa3c"]])

export default __exports__